
import Vue from 'vue'
import store from '@/store'
import AccountTransformer from '@/transformers/account'

/**
 * Updates user account
 * @param  {Object} account The account data
 * @return {Promise}          An http PUT request
 */

export default (account) => {
  return Vue.$http.put('users/current/access_level/')
    .then(({ data }) => {
      return data
    })
}
